import {Flex, Spinner} from "@chakra-ui/react";
import * as React from "react";

const Loading = (props: React.ComponentProps<typeof Flex>) => (
  <Flex height="full" align="center" justify="center" {...props}>
    <Spinner size="xl" color="gray.300" />
  </Flex>
);

export default Loading;
